/** Angular Imports */
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

/** rxjs Imports */
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

/** Custom Services */
import { ClientsService } from '../clients.service';

/**
 * Clients data resolver.
 */
@Injectable()
export class ClientViewResolver {
  private clientsService = inject(ClientsService);

  /**
   * Returns the Clients data.
   * Falls back to null on error so the page can display an appropriate message.
   * @returns {Observable<any>}
   */
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const clientId = route.paramMap.get('clientId');
    return this.clientsService.getClientData(clientId).pipe(
      catchError(() => of(null))
    );
  }
}